import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "attachment-picker-container"
};
import { ref, reactive } from 'vue';
import { acceptedFileTypes, truncateFileName, generateRandomID } from '@/utils/attachmentsToFileSelector.js';
import fileUtilities from '@/services/fileUtilities.js';
import imageUtilities from '@/services/imageUtilities.js';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export default {
  __name: 'AttachmentPicker',
  emits: ['close', 'cancel', 'attachment-selected'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      handleError
    } = useSnackbarHandler();
    const emit = __emit;
    const fileInput = ref(null);
    const attachmentPickerState = reactive({
      filesToUpload: [],
      fileSelector: [],
      attachmentToDelete: null,
      showConfirmationDialog: false,
      dropped: false
    });
    const triggerFileInput = () => {
      const inputElement = fileInput.value?.$el.querySelector('input[type="file"]');
      if (inputElement) inputElement.click();
    };
    const onDragOver = () => {};
    const onDragLeave = () => {};
    const processFiles = async files => {
      for (let file of files) {
        file.fileType = file.type?.toLowerCase();
        file.fileName = file.name;
        if (file.fileName.length > 100) {
          handleError('File name is too long, it will be truncated');
          file.fileName = truncateFileName(file.fileName, 100);
        }
        if (acceptedFileTypes.indexOf(file.fileType) === -1) {
          handleError('Unsupported file type');
          attachmentPickerState.filesToUpload = [];
          attachmentPickerState.dropped = true;
          break;
        }
        if (file.size > 20000001) {
          handleError('Unsupported file size');
          attachmentPickerState.filesToUpload = [];
          attachmentPickerState.dropped = true;
          break;
        }
        const isValid = validateFile(file);
        if (isValid) {
          await prepareFile(file);
        }
      }
      attachmentPickerState.fileSelector = attachmentPickerState.fileSelector.concat(attachmentPickerState.filesToUpload);
      attachmentPickerState.selectedFileIndex = attachmentPickerState.fileSelector.length;
      emit('attachment-selected', attachmentPickerState.fileSelector);
      emit('close');
    };
    const onDrop = event => {
      const files = event.dataTransfer.files;
      attachmentPickerState.filesToUpload = attachmentPickerState.filesToUpload.concat([...files]);
      if (files?.length) processFiles(attachmentPickerState.filesToUpload);
    };
    const validateFile = file => {
      if (!acceptedFileTypes.includes(file.type)) {
        handleError('Unsupported file size');
        return false;
      }
      if (file.size > 20000000) {
        handleError('File size too large');
        return false;
      }
      return true;
    };

    // Prepare file by adding metadata and processing previews
    const prepareFile = async file => {
      file.id = generateRandomID();
      file.fileName = file.name;

      // Image and file preview logic
      if (file.fileType.includes('image') && !file.fileType.includes('tiff')) {
        file.src = await imageUtilities.createPreviewImage(file, 500, 374); // Implement image preview logic
      } else {
        file.src = await fileUtilities.fileToBase64(file); // Implement file to base64 logic
      }
    };

    // Select Attachment
    const selectAttachment = () => {
      if (attachmentPickerState.filesToUpload?.length) {
        const files = attachmentPickerState.filesToUpload;
        processFiles(files);
      }
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_file_input = _resolveComponent("v-file-input");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_card, {
        title: "Upload Attachments"
      }, {
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close'))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "drag-drop-zone",
            onDragover: _withModifiers(onDragOver, ["prevent"]),
            onDragleave: _withModifiers(onDragLeave, ["prevent"]),
            onDrop: _withModifiers(onDrop, ["prevent"])
          }, [_createElementVNode("label", {
            onClick: triggerFileInput,
            class: "text-lg font-medium"
          }, [...(_cache[3] || (_cache[3] = [_createTextVNode(" Drag and drop your files or ", -1), _createElementVNode("span", {
            class: "file-input-trigger"
          }, "Browse files", -1)]))]), _cache[4] || (_cache[4] = _createElementVNode("label", null, "PDF, JPG, and PNG files are allowed (Maximum size 20MB)", -1)), _createVNode(_component_v_file_input, {
            ref_key: "fileInput",
            ref: fileInput,
            accept: _unref(acceptedFileTypes).join(','),
            label: "Drag and drop files here or click to browse files",
            variant: "outlined",
            clearable: "",
            multiple: "",
            modelValue: attachmentPickerState.filesToUpload,
            "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => attachmentPickerState.filesToUpload = $event), selectAttachment],
            class: "hidden-file-input"
          }, null, 8, ["accept", "modelValue"])], 32)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};